import { useEffect } from "react";

/**
 * Inject a JSON-LD <script id> on mount, remove on unmount (pattern: StartPage).
 * `build` is called once per `deps` change. SEO only — never blocks the UI (CK-6320).
 */
export default function useJsonLd(id, build, deps = []) {
  useEffect(() => {
    try {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      script.textContent = JSON.stringify(build());
      document.head.appendChild(script);
    } catch (error) {
      console.error("[CK-6320] /for JSON-LD inject failed", {
        errorCode: error?.code || "CK-6320",
        errorMessage: error?.message,
        id,
        timestamp: new Date().toISOString(),
      });
    }
    return () => {
      try {
        document.getElementById(id)?.remove();
      } catch (error) {
        console.error("[CK-6320] /for JSON-LD remove failed", {
          errorCode: error?.code || "CK-6320",
          errorMessage: error?.message,
          id,
          timestamp: new Date().toISOString(),
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
